import { Injectable } from '@angular/core';

import { Item } from '../../bayadic-shared-models/classes/item/Item';
import { Collection } from '../../bayadic-shared-models/collection/Collection';
// import {AjaxBridgeProvider} from '../ajax-bridid
import { Dictionary } from '../../bayadic-shared-models/classes/modules/Dictionary/Dictionary';
import { Puzzle } from '../../bayadic-shared-models/classes/modules/Puzzle/Puzzle';
import { Chat } from '../../bayadic-shared-models/chat/Chat';
import { ItemsSynchronizer } from './components/synchronizer/ItemsSynchronizer';
import { StorageManagerProvider } from '../storage-manager/storage-manager';
import { SocketManagerProvider } from '../socket-manager/socket-manager';
import { UserManagerProvider } from '../user-manager/user-manager';
import { Events } from '../../providers/events/events';
import { AddItemResponse } from '../../bayadic-shared-models/item/add-item-response';
import { GetPublicItemRequest } from '../../bayadic-shared-models/item/get-public-item-request';
import { AddItemRequest } from '../../bayadic-shared-models/item/add-item-request';
import { ACTIONS } from '../../bayadic-shared-models/enums/Enums';
import { GetItemResponse } from '../../bayadic-shared-models/item/get-item-response';
import { GetItemRequest } from '../../bayadic-shared-models/item/get-item-request';
import { RemoveItemResponse } from '../../bayadic-shared-models/item/remove-item-response';
import { RemoveItemRequest } from '../../bayadic-shared-models/item/remove-item-request';
import { ChatsDatabaseService } from '../chats-database-service/chats-database-service';
import { GetItemsResponse } from '../../bayadic-shared-models/item/get-items-response';
import { GetItemsRequest } from '../../bayadic-shared-models/item/get-items-request';
import { Leitner } from '../../bayadic-shared-models/classes/modules/Leitner/Leitner';
import { Quiz } from '../../bayadic-shared-models/classes/modules/Quiz/Quiz';
import { LoggerService } from '../../app/services/logger.service';
@Injectable({
  providedIn: 'root'
})

export class ItemsManagerProvider {
  async loadLocalSubItems(parentItemID: string): Promise<Item[]>  {
    const storageKey = this.getSubItemsStorageName(parentItemID);
    const storedItems = await this.storageManager.get(storageKey);
    if (storedItems) {
      return storedItems.map(item => new Item(item));
    }
    return [];
  }
  async getOnlineSubItems(parentItemID: string, itemsCreated: Item[]): Promise<Item[]> {
    const items = await this.socketManager.asyncQuery<GetItemsResponse, GetItemsRequest>(ACTIONS.GetItems,
      { parentItemID: parentItemID }
    );
    const updatedItems: Item[] = [];
    for (const itemData of items.items) {
      const item = await this.createItem(itemData);
      await this.storageManager.set(item.itemID, item);
      updatedItems.push(item);
      if (!itemsCreated.some(existingItem => existingItem.itemID === item.itemID)) {
        itemsCreated.push(item);
      }
    }
    const storageKey = this.getSubItemsStorageName(parentItemID);
    await this.storageManager.set(storageKey, updatedItems.map(item => item.getSimpleModel()));
    
    return itemsCreated;
  }

  getSubItemsStorageName(parentItemID: string): string {
    return `${this.userManager.user.userID}_subItems_${parentItemID}`;
  }
  clearMemory() {
    // this.subItems.length = 0;
  }
  clearStorage() {
    this.storageManager.set(this.getItemStorageName(), []);
  }
  async retrieve(itemID: string): Promise<Item | false> {
    let localItem = await this.getLocalItem(itemID);
    if (localItem) return localItem;
    const onlineItem = await this.loadItemByID(itemID);
    return onlineItem
  }
  private async getLocalItem(itemID: string) {
    let localItem = null;
    if (this.items.length === 0 && this.subItems.length === 0) {
      localItem = await this.retrieveSingleItem(itemID);
    }
    else {
      localItem = this.find(itemID);
      if (!localItem) {
        localItem = this.findSubItem(itemID);
      }
    }
    return localItem;
  }

  private async loadItemByID(itemID: string) {
    const data = { itemID: itemID };
    const itemResult = await this.socketManager.asyncQuery<GetItemResponse, GetItemRequest>(ACTIONS.GetItem, data);
    this.logger.debug("online item", itemResult);
    const onlineItem = new Item(itemResult);
    onlineItem.type = itemResult.itemType;
    onlineItem.itemID = itemResult.itemID;
    onlineItem.title = itemResult.itemTitle;
    onlineItem.messagesCount = itemResult.messagesCount || 0;
    return onlineItem;
  }

  async retrieveSingleItem(itemID: string): Promise<Item> {
    return await this.storageManager.get(itemID)
  }
  public items: Array<Item> = [];
  public subItems: Item[] = [];
  public backUpitems: Array<Item> = [];
  public itemsStorage;
  public newItemsNumber: number = 0;
  public synchronizer: ItemsSynchronizer;
  public static actionGetPublicItems = "getPublicItems";
  public publicItems: Array<Item> = [];
  constructor(
    public storageManager: StorageManagerProvider,
    public databaseManager: ChatsDatabaseService,
    public logger: LoggerService,
    // public ajaxBridge: AjaxBridgeProvider,
    public socketManager: SocketManagerProvider,
    private chatsDatabaseService: ChatsDatabaseService,
    public userManager: UserManagerProvider,
    public events: Events
  ) {
    this.userManager.isLoggedIn().then(() => {
      this.itemsStorage = this.userManager.user.userID + "myItems";
    });
    this.synchronizer = new ItemsSynchronizer(this, this.logger);

    this.registerEvents();
    // events.subscribe(Enums.EVENTS.CheckEvents, (data) => {
    //   this.refresh();
    // });


  }

  registerEvents() {
    // this.events.subscribe(Enums.EVENTS.UpdateItems, (data) => {
    //   this.socketManager.asyncQuery(Enums.ACTIONS.GetItem, data);
    // });
    // this can be removed maybe
    // this.events.subscribe(Enums.EVENTS.UpdateMessages, (data) => {
    //   this.socketManager.asyncQuery(Enums.ACTIONS.GetMessage, data);
    // });
  }
  allowTutorial() {
    return this.items.length == 0;
  }
  deleteItem(item: Item) {
    this.socketManager.asyncQuery<RemoveItemResponse, RemoveItemRequest>
    (ACTIONS.removeItem, {
      item: {
        itemID: item.itemID
      }
    });
    this.deleteItemLocally(item);
  }
  deleteItemLocally(item: Item) {
    let itemIndex = this.items.indexOf(item);
    if(itemIndex>=0){
      this.items.splice(itemIndex, 1);
      this.chatsDatabaseService.deleteTable(item.itemID)
      this.storageManager.set(this.getItemStorageName(), this.getSimpleModelOfItems());
      this.storageManager.set(this.getItemStorageName() + item.itemID, null);
    }
  }
  async insertItemToList(item: Item) {
    this.items.push(item);
    await this.storageManager.set(item.itemID, item);
    this.saveUpdateItemsInLocalDB();
  }
  public async createItems(itemsCreated: Array<string>) {
    this.logger.debug("creating items 34", itemsCreated);
    for (let itemID of itemsCreated) {
        const createdItem = await this.createItem(itemID);

        this.insertItemToList(createdItem);
    }
}
  private async createItem(itemID: string): Promise<Item> {
    const createdItem = new Item({});
    createdItem.itemID = itemID;
    const data = { itemID: createdItem.itemID };
    const itemData = await this.socketManager.asyncQuery<GetItemResponse, GetItemRequest>(ACTIONS.GetItem, data);
    createdItem.title = itemData.itemTitle;
    createdItem.type = itemData.itemType;
    createdItem.messagesCount = itemData.messagesCount || 0;
    return createdItem;
  }

  async refresh() {
    await this.loadLocalItems();
    await this.synchronizer.sync();
  }
  private async loadLocalItems() {
    const myItems = await this.storageManager.get(this.getItemStorageName());

    if (myItems) {
      for (const itemObj of myItems) {
        const item = new Item(itemObj);
        if (!this.hasItem(item)) {
          this.items.push(item);
        }
        else {
          this.logger.debug("ignoring item");
        }
      }
    }
  }

  hasItem(item: Item) {
    let listedItems = this.items.filter(listedItem => item.itemID === listedItem.itemID)
    return listedItems.length > 0;
  }
  async add(item: Item) {
    this.items.push(item);
    await this.chatsDatabaseService.createTablesIfNotExists(item.itemID)
    this.saveUpdateItemsInLocalDB();
  }
  getItemStorageName() {
    this.itemsStorage = this.userManager.user.userID + "myItems";
    return this.itemsStorage;
  }
  searchBackUp() {
    this.backUpitems = [];
    for (let item of this.items) {
      this.backUpitems.push(item);
    }
  }
  async search(needle: string) {
    if (!needle) {
      return false;
    }
    this.items = this.backUpitems.filter(item => {
      if (item.title.includes(needle))
        return item;
    });
    const response = await this.socketManager.asyncQuery<GetPublicItemResponse, GetPublicItemRequest>(
      ItemsManagerProvider.actionGetPublicItems, { 'needle': needle }
    )
    if (response.publicItemsData.length > 0) {
      this.publicItems.length = 0;
      for (const itemData of response.publicItemsData) {
        const publicItem = this.createItemByItemData(itemData);
        publicItem.setAutoInit(false);
        this.publicItems.push(publicItem);
      }
    }
  }
  endSearch() {
    this.publicItems.length = 0;
    this.items = this.backUpitems;
  }
  async saveUpdateItemsInLocalDB() {
    await this.storageManager.set(this.getItemStorageName(), this.getSimpleModelOfItems());
  }
  getSimpleModelOfItems() {
    let simpleModelOfItems: Array<Item> = [];
    for (let item of this.items) {
      simpleModelOfItems.push(item.getSimpleModel())
    }
    return simpleModelOfItems;
  }
  find(itemID: string): Item {
    const item = this.items.filter(item => item.itemID === itemID)[0]
    return item
  }
  findSubItem(itemID: string): Item {
    const item = this.subItems.filter(item => item.itemID === itemID)[0]
    return item
  }
  async addItem(item: Item) {
    const itemResult = await this.socketManager.asyncQuery<AddItemResponse, AddItemRequest>(ACTIONS.addItem, {
      item: {
        status: item.status,
        title: item.title,
        type: item.type
      }
    })
    item.itemID = itemResult.itemID
    await this.insertItemToList(item)
    return itemResult;
  }

  async addNewItem(item: Item) {
    const response = await this.addItem(item);
    item.itemID = response.itemID;
    item.setUserID(this.userManager.user.userID);
    this.add(item);
  }
  clearNotification() {
    this.newItemsNumber = 0;
  }
  getNotificationsNumber() {
    return this.newItemsNumber;
  }
  createItemFromCollection(collection: Collection) {
    let item = new Item(collection);
    if (collection.type == Collection.typeDictionary) {
      item = new Dictionary(collection);
    }
    else if (collection.type == Collection.typeLeitner) {
      item = new Leitner(collection);
    }
    else if (collection.type == Collection.typeQuiz) {
      item = new Quiz(collection);
    }
    return item;
  }
  createItemByItemData(itemData) {
    let item: Item;
    switch (itemData.itemType) {
      case "dictionary":
        item = new Dictionary(itemData);
        break;
      case "puzzle":
        item = new Puzzle(itemData);
        break;
      case "quiz":
      case "artikelQuiz":
      case "imageQuiz":
      case "translationQuiz":
        item = new Dictionary(itemData);
        break;
      case "leitner":
        item = new Dictionary(itemData);
        break;
      default:
        item = new Dictionary(itemData);
        break;
    }
    return item;
  }



}
interface AddedItemResponse {
  itemId: string;
}
interface GetPublicItemResponse {
  publicItemsData: Array<Item>;
}
